import { createDTAppMigrationFunction } from '@design-system/migration-utils';

import { codemodOrder } from './codemod-order.js';

/**
 *
 */
module.exports = createDTAppMigrationFunction(codemodOrder);
